// config/setting.js  代理配置请修改vue.config
const config = {
	baseTitle:"西仓ERP",
	//默认域名 web的域名及访问地址 http://192.168.1.190:8080 线上 https://erp.jsxicang.com
	// baseDomain: 'http://192.168.1.37:8080',//本地 测试环境
	baseDomain: 'https://erp.jsxicang.com',//正式环境
	// 默认的请求地址 api地址 本地：192.168.1.190:8100 线上 https://erp.jsxicang.com/api/
	baseURL: ' https://erp.jsxicang.com/api/',
	// baseURL: 'http://192.168.1.37:8100',
	adminPath: '/admin',
	//缓存相关key值配置
	userInfoKey:"userInfo",
	//默认点击logo的路径
	adminIndex:"/admin/console",
	//登录状态验证令牌
	tokenKey:"Authorization",
	//企业编码
	factoryCodeKey:"factory-code",
};
const service = {
	//正则去除baseDomain的http:// 或 https://
	localDomain: config.baseDomain.replace(/^https?:\/\//, ''),
	//正则去除baseURL的baseURL
	apiDomain: config.baseURL.replace(/^https?:\/\//, ''),
}

module.exports = {
	config,
	service
}
